import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'password'
})
export class PasswordPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    // Replace value with asterisks
    return '&bull;'.repeat(value.length);
  }
}
